/** Wyliczany przez backend: zapisujący jest anulowany, gdy żadna jego rezerwacja (po scaleniu wierszy) nie jest aktywna. */
export enum ClientStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
}
